import PhoneVerificationContainer from './container'
import PhoneVerificationUI from './ui'
import PhoneVerificationReduxForm, {
  PhoneInputField,
} from './reduxFormContainer'
import * as utils from './utils'
import { removePhone } from './providers'
export default {
  PhoneVerificationContainer,
  PhoneVerificationUI,
  PhoneVerificationReduxForm,
  PhoneInputField,
  utils,
  providers: {
    removePhone,
  },
}
